var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
var SettingNav = /** @class */ (function (_super) {
    __extends(SettingNav, _super);
    function SettingNav() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SettingNav.prototype, "permissions", {
        /* computed */
        get: function () {
            return this.$store.state.common.permission || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SettingNav.prototype, "user", {
        get: function () {
            return this.$store.state.common.user || {};
        },
        enumerable: false,
        configurable: true
    });
    /* methods */
    SettingNav.prototype.checkActive = function (item) {
        return this.$route.path.indexOf(item) > -1;
    };
    SettingNav = __decorate([
        Component
    ], SettingNav);
    return SettingNav;
}(Vue));
export default SettingNav;
